import { ImageCompressSetting } from '@app/types/src/system'

export default class SystemConstants {
  static readonly redirectKey: string = 'login_redirect' //localstrorageリダイレクト先
  static readonly deviceIdKey: string = 'device_id' //localstrorageデバイスID
  static readonly repairRouteKey: string = 'is_repair_route' //localstrorage修理依頼導線フラグ
  static readonly imageCompress: ImageCompressSetting = {
    quality: 0.7,
    maxWidth: 1920,
  }
}
